export const modes = [
    {
        value: 0,
        label: 'input'
    },
    {
        value: 1,
        label: 'timer'
    },
    {
        value: 2,
        label: 'thermostat'
    },
    {
        value: 3,
        label: 'hydrostat'
    }
]